import { render } from "./ProceedButton.vue?vue&type=template&id=69e67469"
import script from "./ProceedButton.vue?vue&type=script&lang=ts"
export * from "./ProceedButton.vue?vue&type=script&lang=ts"

import "./ProceedButton.vue?vue&type=style&index=0&id=69e67469&lang=scss"
script.render = render

export default script